//=====================================================
//　メールアドレステキストボックス
//=====================================================

import { useContext } from "react";
import { InputTag } from "../utils/ConstCommon";
import { getMsg, ConstMsg } from "../utils/ConstMsg";
import { CtxClinicSystemInfo } from "../utils/Contexts";
import { InputTextBase } from "./InputTextBase";
import { LblInput } from "./LblInput";
import { ValidErrMsgInline } from "./ValidErrMsgInline";

interface IFProps {
    name: string,
}

const FORM_TITLE = "E-mail";

export function TxtEmail(props: IFProps) {

    const ccsi = useContext(CtxClinicSystemInfo);
    
    //バリデーション
    const validations = {
        pattern: {value: /^[\w_+.-]+@[\w_+.-]+$/, message: ConstMsg.EG0040008},
        maxLength: {value: 255, message: getMsg(ConstMsg.EG0040003, [FORM_TITLE, "255"])},
        ...(ccsi.data.usability.patientEmail ? {required: getMsg(ConstMsg.EG0040001, [FORM_TITLE])} : {})
    }

    return (
        <div className="input-box">
            <LblInput title={FORM_TITLE} tag={ccsi.data.usability.patientEmail ? InputTag.Required : InputTag.Optional} />
            <ValidErrMsgInline name={props.name}/>
            <InputTextBase name={props.name} className="input-text-mail" placeholder="例）example@dentnet.co.jp" validations={validations} type="email"/>
        </div>
    )

}